// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"65a8ad16","459":"32f7336e","595":"53f26372"}[chunkId] + ".chunk.css";
};